// ante-react-kit/src/pos/AntCashPickupPopup/index.js
import React, { useState } from 'react';
import { NumberBox, TextArea, SelectBox } from 'devextreme-react';
import AntPasscodeOverlay from '../../components/AntPasscodeOverlay';
import AntAuth from '../../utils/AntAuth';

export default function AntCashPickupPopup(props) {
    const { session, onDone, onClose } = props;
    const [amount, setAmount] = useState(0);
    const [reason, setReason] = useState('');
    const [sourceAccount, setSourceAccount] = useState(null);
    const [errorText, setErrorText] = useState('');
    const [errorKey, setErrorKey] = useState(0);
    const [processing, setProcessing] = useState(false);

    const useCA = AntAuth.getBusSetting('use_Module_CA') === 1;
    const reportError = (msg) => { setErrorText(msg); setErrorKey((k) => k + 1); };

    const handleComplete = (passCode) => {
        if (!amount || amount <= 0) { reportError('Nhập số tiền'); return; }
        if (!reason) { reportError('Nhập lý do'); return; }
        setProcessing(true);
        AntAuth.callApi('user/ACUserAuthen/cashShift/pickup', {
            amount, reason, source_cash_account_code: sourceAccount, pass_code: passCode
        }, (res) => {
            setProcessing(false);
            if (res && res.error) { reportError((res.error.message && res.error.message.vi) || 'Lỗi'); return; }
            if (onDone) onDone(res && res.data);
        });
    };

    const topSlot = (
        <div className="apt-shift-top">
            <div className="apt-shift-row">
                <span className="apt-shift-label">Số tiền</span>
                <NumberBox value={amount} onValueChanged={(e) => setAmount(e.value)} format="#,##0" width={180} />
            </div>
            <div className="apt-shift-row">
                <span className="apt-shift-label">Lý do</span>
                <TextArea value={reason} onValueChanged={(e) => setReason(e.value)} height={60} width={260} />
            </div>
            {useCA && (
                <div className="apt-shift-row">
                    <span className="apt-shift-label">Két nguồn</span>
                    <SelectBox
                        value={sourceAccount} onValueChanged={(e) => setSourceAccount(e.value)}
                        dataSource={[]} width={180} placeholder="Chọn két..."
                    />
                </div>
            )}
        </div>
    );

    return (
        <AntPasscodeOverlay
            title="Bổ sung quỹ"
            subtitle="Nhận tiền vào két ca"
            topSlot={topSlot}
            bottomActions={<button type="button" className="apt-passcode-secondary-btn" onClick={onClose}>Huỷ</button>}
            processing={processing}
            errorText={errorText}
            errorKey={errorKey}
            onComplete={handleComplete}
            dismissible={true}
            onDismiss={onClose}
        />
    );
}
